<template>
	<div class="flex a-center">
		<div class="progress-container" id="container" ref="progressContainer" :style="{ background: inBgColor }">
			<div class="progress-content flex j-end j-center" id="content" ref="progressContent"
				:style="{ height: strokeWidth + 'px', background: `linear-gradient(to right, ${skinType === 1 ? bgSkinType1Color : bgSkinType2Color},${skinType === 1 ? bgSkinType1Color1 : bgSkinType2Color1})`, width: contentWidth, transition: `width ${duration / 1000}s ease` }"
				v-if="isAnimate">
			</div>
			<div class="step-text" @click="handleSetp">
				{{ typeText }}：
				<span :class="{ 'color-red': curValue < maxValue, 'color-f': curValue >= maxValue }"> {{ curValue }}</span>
				/{{ maxValue }}
			</div>
		</div>
		<div>
			<slot name="right"></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AiProgress',
	components: {},
	props: {
		// 进度条的值
		percentage: {
			type: [Number, String],
			required: true
		},
		// 当前进度
		curValue: {
			type: [Number],
			required: true
		},
		maxValue: {
			type: [Number],
			required: true
		},
		activityType: {
			type: Number,
			default: 1 //type{ 1固定投注金额 2上周期投注金额比例 ,新增：3固定存款金额}
		},
		// 是否内联显示数据
		textInside: {
			type: Boolean,
			default: true
		},
		// 进度条高度
		strokeWidth: {
			type: [Number, String],
			default: 32
		},
		// 默认动画时长
		duration: {
			type: [Number, String],
			default: 2000
		},
		// 是否有动画
		isAnimate: {
			type: Boolean,
			default: true
		},
		// 背景颜色
		bgSkinType1Color: {
			type: String,
			default: '#FF8E00'
		},
		bgSkinType1Color1: {
			type: String,
			default: '#E9605A'
		},
		// 背景颜色
		bgSkinType2Color: {
			type: String,
			default: '#00AE7F'
		},
		bgSkinType2Color1: {
			type: String,
			default: '#007746'
		},
		// 是否不显示数据
		noData: {
			type: Boolean,
			default: false
		},
		// 是否自定义显示内容
		lineData: {
			type: Boolean,
			default: false
		},
		// 自定义底色
		inBgColor: {
			type: String,
			default: '#F2E8D9'
		},
		//皮肤类型
		skinType: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			width: 0,
			timer: null,
			containerWidth: 0,
			contentWidth: 0,
			typeText: ' 已投注'
		};
	},
	methods: {
		handleSetp() {
			this.$emit('handleSetp')
		},
		start() {
			if (this.activityType == 1) {
				this.typeText = '已投注';
			}
			else if (this.activityType == 3) {
				this.typeText = '已充值';
			}

			if (this.isAnimate) {
				this.$nextTick(() => {
					let progressContainer = this.$refs.progressContainer;
					let progressContent = this.$refs.progressContent;
					console.log("progressContainer", progressContainer)
					if (!progressContainer || !progressContent) {
						return false
					}
					let style = window.getComputedStyle(progressContainer, null);
					let width = style.width.replace('px', '') * ((this.curValue * 1) / this.maxValue);
					progressContent.style.width = width.toFixed(2) + 'px';
					progressContent.style.transition = `width ${this.duration / 1000}s ease`;
				});
			}
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.start();
		});
	},
	created() { },
	filters: {},
	computed: {},
	watch: {},
	directives: {}
};
</script>

<style scoped lang="scss">
.content {
	margin-bottom: 10px;

	.c-per {
		font-size: 26px;
	}
}

.progress-container {
	overflow: hidden;
	flex: 1;
	height: 64upx;
	border-radius: 100px;
	fill: var(--f-2-e-8-d-9, #F2E8D9);
	stroke-width: 1px;
	stroke: var(--d-9-b-98-e, #D9B98E);
	position: relative;

	.progress-content {
		border-radius: 100px;
		width: 0;
	}

	.textInside {
		color: #fff;
		margin-right: 5px;
		position: relative;
	}

	.step-text {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 30px;
		line-height: 32px;
		text-align: center;
		color: #4D381B;
		font-size: 12px;
		z-index: 1;
		font-family: Source Han Sans CN;
	}

	.color-red {
		color: #F00;
	}

	.color-f {
		color: #FFFFFF;
	}

	.color-green {
		color: #017B4A
	}
}

.text {
	margin-left: 5px;
}

.percentage {
	margin-left: 6px;
	font-size: 12px;
	width: 30px;
}

.flex {
	display: flex;
}

.a-center {
	align-items: center;
}

.j-center {
	justify-content: center;
}

.j-between {
	justify-content: space-between;
}

.content {
	margin-bottom: 10px;
	color: #666;
	font-size: 16px;
}

.border-f {
	border: 1px solid #FFFFFF;
}
</style>